// Basic
import PropTypes from 'prop-types';
// Libs
import { DateTime } from 'luxon';
// Store & actions
import actionsSubscriptions from '@/app/modules/subscriptions/api/actionsSubscriptions';
// Components
import HeaderTitle from '@/common-utils/components/renders/modal/components/headers/HeaderTitle/HeaderTitle';
import Spinner from '@/common-utils/components/renders/spinner/Spinner';
import DetailsGrid from '@/common-utils/components/renders/detailsGrid/DetailsGrid';
import Entity from '@/common-utils/components/renders/entity/Entity';
import FooterClose from '@/common-utils/components/renders/modal/components/footers/FooterClose/FooterClose';
import { Modal, ModalBody, ModalContent } from '@/common-utils/components/ui/modal';
import { Badge } from '@/common-utils/components/ui/badge';
// Common
import posTerminalFields from '../../../fields/posTerminalFields';
import POS_TERMINAL_STATUS from '../../../enums/PosTerminalStatus';
// Lang
import { nsTerminal } from '@/app/i18n/namespaces';

/**
 * @param root0
 * @param root0.isOpen
 * @param root0.setIsOpen
 * @param root0.subscriptionId
 * @returns {JSX} ModalShowPosTerminalInfo
 */
function ModalShowPosTerminalInfo({ isOpen, setIsOpen, subscriptionId }) {

    // Api Calls
    const { data: infoPosTerminalStatus, error, isLoading } = actionsSubscriptions.getPosTerminalStatusInfo(subscriptionId);

    const posTerminalInfoFields = Object.fromEntries(
        Object.entries(posTerminalFields).filter(([key]) =>
            [
                'SERIAL_NUMBER',
                'MANUFACTURER',
                'STATUS_IN_DATEBASE'
            ].includes(key)));

    return (
        <Modal open={isOpen} onOpenChange={setIsOpen}>
            <ModalContent className='max-w-lg'>
                <HeaderTitle title='modal.info_status.title' namespace={nsTerminal} />
                <ModalBody className='modal-body-max-height overflow-auto'>
                    {
                        error && <p>{JSON.stringify(error)}</p>
                    }
                    {
                        isLoading ?
                            <Spinner className='mt-8' />
                            : infoPosTerminalStatus &&
                            <div>
                                {
                                    <DetailsGrid fields={posTerminalInfoFields} data={infoPosTerminalStatus} isModal />
                                }
                                <div>
                                    <Entity className={'font-bold underline'} namespace={nsTerminal} entity={'modal.info_status.gateway'} />
                                </div>
                                {
                                    infoPosTerminalStatus.redisKeysFetched && infoPosTerminalStatus.redisKeysFetched.length > 0 ?
                                        <div>
                                            <div className='my-2'>
                                                <Entity
                                                    className={'font-bold'}
                                                    entity={'modal.info_status.fetching_time'}
                                                    namespace={nsTerminal} />: {infoPosTerminalStatus.redisKeyFetchDuration} ms</div>
                                            <div>
                                                <Entity className={'font-bold'} namespace={nsTerminal} entity={'modal.info_status.key_list_redis'} />
                                            </div>
                                            <div >
                                                <ol className='space-y-4 mx-4 my-2 list-decimal'>
                                                    {infoPosTerminalStatus.redisKeysFetched.map((item) => (
                                                        <li key={item.key}>
                                                            <Entity className={'font-bold'}
                                                                namespace={nsTerminal} entity={'modal.info_status.connexion_point'} />:{item.key}<br />
                                                            <Entity className={'font-bold'} namespace={nsTerminal} entity={'modal.info_status.value'} />:
                                                            {item.value && item.value.startingDate ? ` {"startingDate":"${item.value.startingDate}"}` : ' '}<br />
                                                            <div>
                                                                <Entity className={'font-bold'} namespace={nsTerminal}
                                                                    entity={'modal.info_status.status'} />:
                                                                <Badge className='mx-2'
                                                                    entity={POS_TERMINAL_STATUS[item.status].entity}
                                                                    namespace={POS_TERMINAL_STATUS[item.status].namespace}
                                                                    variant={POS_TERMINAL_STATUS[item.status].variant} />
                                                                {item.status === POS_TERMINAL_STATUS.TEMPORARILY_ALLOWED.name &&
                                                                    <Entity className='mr-1' namespace={nsTerminal} entity={'modal.info_status.till'} />}
                                                                {item.startDate && DateTime.fromISO(item.startDate)
                                                                    .toLocaleString(DateTime.DATETIME_FULL).split('UTC')[0]}
                                                            </div>
                                                            <p></p>
                                                        </li>
                                                    ))}
                                                </ol>
                                            </div>
                                        </div> : ' '
                                }
                            </div>
                    }
                </ModalBody>
                <FooterClose />
            </ModalContent>
        </Modal>
    );
}

export default ModalShowPosTerminalInfo;

ModalShowPosTerminalInfo.propTypes = {
    isOpen: PropTypes.bool,
    setIsOpen: PropTypes.func,
    subscriptionId: PropTypes.string
};